import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { capitalizeWords } from "../../../Utils";

const Harianusp = (data, tglmulai, tglakhir ) => {

  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;  
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

  const formatNumber = (num) => {
    return num === null || num === undefined || isNaN(num) ? "-" : parseFloat(num).toLocaleString("id-ID");
  };

  const formatTanggal = (tanggal) => {
    if (!tanggal) return "-";

    const date = new Date(tanggal);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ingat: getMonth() mulai dari 0
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  const reportY = lineY + 7;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(
    "Laporan Harian Simpanan USP",
    pageWidth / 2,
    reportY,
    {
      align: "center",
    }
  );

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(
    `Tanggal : ${formatTanggal(tglmulai)} s/d ${formatTanggal(tglakhir)}`,
    pageWidth / 2,
    reportY + 5,
    {
      align: "center",
    }
  );

  return reportY + 9;
};

  const headers = [[
    { content: "No", styles: { halign: "left" } },
    { content: "Tanggal", styles: { halign: "center" } },
    { content: "No.Transaksi", styles: { halign: "center" } },
    { content: "No.Anggota", styles: { halign: "center" } },
    { content: "Nama", styles: { halign: "left" } },
    { content: "Simp.Pokok", styles: { halign: "left" } },
    { content: "Simp.Wajib", styles: { halign: "left" } },
  ]];

  let totalSPokok = 0;
  let totalSWajib = 0;
 
  let tableData = data.map((item, index) => {    
    totalSPokok += item.spokok || 0;
    totalSWajib += item.swajib || 0;

    return [
      { content: index + 1, styles: { halign: "right" } }, 
      { content: formatTanggal(item.tanggal) ?? "-", styles: { halign: "center" } },
      { content: item.notransaksi ?? "-", styles: { halign: "center" } },      
      { content: item.noanggota ?? "-", styles: { halign: "center" } },
      capitalizeWords(item.nama),
      { content: formatNumber(item.spokok), styles: { halign: "right" } },
      { content: formatNumber(item.swajib), styles: { halign: "right" } }      
    ];
  });

  tableData.push([
    { 
      content: "Total Keseluruhan", 
      colSpan: 5, 
      styles: { 
        fontStyle: "bold", 
        halign: "center", 
        fillColor: [230, 230, 230], 
      } 
    }, 
    { 
      content: formatNumber(totalSPokok), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230], 
      } 
    },
    { 
      content: formatNumber(totalSWajib), 
      styles: { 
        fontStyle: "bold", 
        halign: "right", 
        fillColor: [230, 230, 230], 
      } 
    }  
  ]);  

 const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: startY,
    theme: "grid",

    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      overflow: "linebreak",
    },

    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
      fillColor: [0, 191, 165],
      textColor: 255,
    },

    showHead: "everyPage",

    margin: {
      left: 9,
      right: 9,
      top: 20,
      bottom: 10,
    },

    tableWidth: "stretch",

    columnStyles: {
      0: {
        cellWidth: 10,
        halign: "right",
      },
      1: {
        cellWidth: 20,
        halign: "center",
      },
      2: {
        cellWidth: 25,
        halign: "center",
      },
      3: {
        cellWidth: 25,
        halign: "center",
      },
      4: {
        cellWidth: "auto",
        halign: "left",
        overflow: "linebreak",
      },
      5: {
        cellWidth: 25,
        halign: "right",
      },
      6: {
        cellWidth: 25,
        halign: "right",
      },
    },

    didDrawPage: (data) => {
      doc.setFontSize(8);
      doc.text(
        `Page ${doc.internal.getNumberOfPages()}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    const startY = drawHeader(logoDataUrl);
    renderTable(startY);
  })
  .catch((err) => {
    console.warn("Logo tidak ditemukan:", err);

    const startY = drawHeader();
    renderTable(startY);
  });
};

export default Harianusp;